"use client";

interface BodyCustomCode {
  code?: string;
}

export default function BodyCustomCode({ code }) {
  return <div dangerouslySetInnerHTML={{ __html: code }} />;
}
